import { TicketAddPage } from "./../../backoffice/tickets/add/add";
import { CollectionPointPage } from "./../../backoffice/collecion-points/index";
import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  AlertController
} from "ionic-angular";
import { Storage } from "@ionic/storage";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import { TransferSiteModalComponent } from "../../backoffice/shipments/transfer-site-modal/transfer-site-modal";
import { HoldRtoModalComponent } from "./hold-rto-modal/hold-rto-modal";
import { ConfirmCancellationModalComponent } from "./confirm-cancellation-modal/confirm-cancellation-modal";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { AuthService } from "../../../providers/auth-service";
import { CreateDHLShipment } from "../../backoffice/create-dhl-shipment";

@Component({
  selector: "search-parcel-page",
  templateUrl: "index.html",
  providers: [WaybillOrderServiceProvider, SummaryServiceProvider]
})
export class SearchParcel {
  header_data: any;
  params: Object;
  pushPage: any;
  noResultErr: any;
  createTicketPage: any;
  public awb_number: string = "";

  showMenuItems: any = false;
  selectedItem: any;
  icons: string[];
  items: Array<{ title: string; note: string; icon: string }>;

  public waybills: any;
  public user_permissions: any;
  currency: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public waybillOrderService: WaybillOrderServiceProvider,
    public loadingCtrl: LoadingController,
    public summaryService: SummaryServiceProvider,
    private storage: Storage,
    private auth: AuthService
  ) {
    let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
    if (userInfo.username == "dm" || userInfo.username == "mukesh" || userInfo.username == "Mukesh") {
      this.showMenuItems = true;
    }
    if (userInfo) {
      this.currency = userInfo.currency;
    }

    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Search Parcel",
      parentReloadData: d => {
        this.searchWaybill();
      }
    };

    this.storage.get("user_permission").then(data => {
      var c: any = JSON.parse(data);
      this.user_permissions = c;
    });

    if (this.navParams.get("awb")) {
      this.awb_number = this.navParams.get("awb");
      this.searchWaybill();
    }

    this.pushPage = CollectionPointPage;
    this.createTicketPage = TicketAddPage;
  }

  searchWaybill() {
    this.noResultErr = false;
    var awb_number: String = this.awb_number;

    //this.clipboard.copy('Hello world');

    let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();

    //alert(awb_number);

    this.waybillOrderService.search(awb_number).then(data => {
      this.waybills = data;
      if (this.waybills.code == "1001") {
        if (this.waybills.data.orderNo) {
          if (this.waybills.data.statusHistories.length > 0) {
            this.waybills.data.statusHistories.map(ele => {
              if (ele.action_time.slice(-1) == "Z") {
                ele.action_time = ele.action_time.slice(0, -1);
              }
              return ele;
            });
          }
        } else {
          this.noResultErr = true;
        }
      } else {
        this.noResultErr = true;
      }
    });
    loader.dismiss();
  }

  transferSiteModal(data) {
    const modal = this.modalCtrl.create(TransferSiteModalComponent, {
      data: data
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.searchWaybill();
      }
    });
    modal.present();
  }

  holdRto(data) {
    const modal = this.modalCtrl.create(HoldRtoModalComponent, { data: data });
    modal.onDidDismiss(data => {
      if (data) {
        this.searchWaybill();
      }
    });
    modal.present();
  }

  // cancelShipment() {
  //   //1158879279
  //   var message = "Do you want to Cancel this Parcel";
  //   let alert = this.alertCtrl.create({
  //     title: 'Confirm',
  //     message: `${message}`,
  //     buttons: [
  //       {
  //         text: 'No',
  //         role: 'cancel',
  //         handler: () => {
  //           console.log('Cancel clicked');
  //         }
  //       },
  //       {
  //         text: 'Yes',
  //         handler: () => {
  //           var payload = {
  //             orderNos: [this.waybills.data.orderNo]
  //           }
  //           console.log(payload);
  //           this.summaryService
  //             .cancelShipment(payload)
  //             .then((res: any) => {
  //               console.log(res);
  //               if (res.code == 1001) {
  //                 console.log("Confirmed");
  //                 this.searchWaybill();
  //               }
  //             });
  //         }
  //       }
  //     ]
  //   });
  //   alert.present();
  // }

  redirectToPage(menu) {
    if (menu == "CreateDHLShipment") {
      this.navCtrl.push(CreateDHLShipment);
    }
  }

  cancelShipment(data) {
    const modal = this.modalCtrl.create(ConfirmCancellationModalComponent, {
      data: data
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.searchWaybill();
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/qdb/search-parcel/index.ts